<script>
    import Kulr from './Kulr.svelte';
    export let colors = ['fff']

    let fsize = 1
    if (5/colors.length >= 1){
        fsize += 5/colors.length
    } else {
        fsize = fsize * 5/colors.length
    }

</script>

{#each colors as color}
    <Kulr fsize={fsize} color={color} />
{/each}